<ng-container *upuTranslate="let t">
  <button
    #trigger="matMenuTrigger"
    id="user-menu-button"
    class="flex items-center rounded-xl focus-visible:outline-primary outline-offset-2"
    [matMenuTriggerFor]="menu"
    [attr.aria-label]="t('topBar.openUserMenu')"
    aria-haspopup="true"
    aria-controls="user-menu"
  >
    <div
      class="size-9 rounded-full bg-[#F2F4F9] border flex items-center justify-center text-primary text-sm font-semibold select-none"
    >
      {{ currentUser()?.displayName | upuUserInitials }}
    </div>

    <mat-icon
      class="text-foreground-secondary text-2xl will-change-transform transition-transform duration-200"
      [class.rotate-180]="trigger.menuOpen"
      aria-hidden="true"
    >
      keyboard_arrow_down
    </mat-icon>
  </button>

  <mat-menu
    id="user-menu"
    #menu="matMenu"
    class="min-w-72 mt-1 bg-main"
    role="menu"
  >
    <div class="flex flex-col gap-1.5 w-full py-2 px-2">
      <div class="flex gap-3">
        <div
          class="shrink-0 size-9 rounded-full bg-[#F2F4F9] flex items-center justify-center text-primary text-sm font-semibold select-none"
        >
          {{ currentUser()?.displayName | upuUserInitials }}
        </div>

        <div class="flex-1 flex flex-col truncate">
          <span class="text-md text-foreground font-semibold">
            {{ currentUser()?.displayName }}
          </span>

          <span class="text-md truncate">{{ currentUser()?.email }}</span>

          <div
            class="mt-2 flex flex-col gap-1 truncate text-sm text-foreground-secondary"
          >
            <span class="badge purple">
              {{ t('roles.' + currentUser()?.roles?.[0]) }}
            </span>

            @if (
              userRole() !== 'Unspecified' &&
              userRole() !== 'Administrator' &&
              userRole() !== 'Superuser'
            ) {
              <p class="flex items-center gap-2">
                <span class="truncate">
                  @let associations =
                    (userRole() === 'SecurityFocalPoint'
                      ? currentUser()?.assignedCountries
                      : currentUser()?.regions) ?? [];

                  @let associationCount = associations.length;
                  @let associationName = associations?.[0]?.name;

                  {{
                    associationName ??
                      t(
                        userRole() === 'SecurityFocalPoint'
                          ? 'common.noAssignedCountries'
                          : 'common.noAssignedRegions'
                      )
                  }}

                  @if (associationCount > 1) {
                    <span class="inline-block ml-1.5">
                      +{{
                        associationCount - 1 < 100 ? associationCount - 1 : '99'
                      }}
                    </span>
                  }
                </span>
              </p>
            }
          </div>
        </div>
      </div>
    </div>

    @for (action of menuOptions(); track action.id) {
      @let visible =
        typeof action.visible === 'function'
          ? action.visible()
          : (action.visible ?? true);

      @let disabled =
        typeof action.disabled === 'function'
          ? action.disabled()
          : (action.disabled ?? false);

      @if (visible) {
        @if (action.separator) {
          <mat-divider />
        }

        <a
          [id]="action.id"
          #al="routerLinkActive"
          mat-menu-item
          type="button"
          class="group [&.active]:bg-primary-highlight [&.active]:text-primary"
          [routerLink]="action?.link"
          [routerLinkActive]="action.link ? 'active' : ''"
          [matMenuTriggerFor]="action.children ? nestedMenu : null"
          [class]="action.styleClass"
          [disabled]="disabled"
          (click)="action.onClick && action.onClick(null)"
        >
          {{ t(action.label ?? '') }}

          <mat-icon [class.mat-symbol-filled]="al.isActive">
            {{ action.icon }}
          </mat-icon>
        </a>

        <mat-menu #nestedMenu="matMenu" xPosition="before" class="w-36 mr-1">
          @for (childAction of action.children || []; track childAction.id) {
            <button
              [id]="childAction.id"
              mat-menu-item
              type="button"
              (click)="switchLanguage(childAction.value)"
            >
              <div class="flex justify-between">
                <span class="text-md">
                  {{ t(childAction.label ?? '') }}
                </span>

                @if (activeLang() === childAction.value) {
                  <mat-icon class="size-fit text-2xl m-0">check</mat-icon>
                }
              </div>
            </button>
          }
        </mat-menu>
      }
    }
  </mat-menu>
</ng-container>
